/**
 * Tip component.
 */
import Bold from '@components/atoms/text/bold';
import TextContainer from '@components/atoms/text/tip';
import TranslationManager from '@shared/assets/locale/translationsManager';

export default function Tip() {
  return (
    <TextContainer id={'tipContainer'}>
      {TranslationManager.get('COMPONENTS.TIP.ACTIONS1')}
      <Bold>{TranslationManager.get('COMPONENTS.TIP.ACTIONS_CONFIRM')}</Bold>
      {TranslationManager.get('COMPONENTS.TIP.ACTIONS2')}
    </TextContainer>
  );
}
